import styled from 'styled-components';
import colors from '../../../../includes/colors';

export const Link = styled.a`
  &:focus, &:active {
    color: ${colors.darkBlue};
  }
  color: ${colors.paleBlue};
  font-size: 1rem;
  padding-bottom: .3rem;
  @media (min-width: 480px) {
    padding-bottom: .6rem;
    font-size: 1.12rem;
  }
`;